import { render, staticRenderFns } from "./ModalPeopleFound.vue?vue&type=template&id=3fd4f7b5&scoped=true"
import script from "./ModalPeopleFound.vue?vue&type=script&lang=js"
export * from "./ModalPeopleFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd4f7b5",
  null
  
)

export default component.exports